import { defineComponent as _defineComponent } from 'vue'
import { applyReactInVue } from 'vuereact-combined';

import { useBilling } from '@/components/Billing/Billing.composables';
// @ts-ignore
import UpgradeRequiredIndicator from '@/components/Billing/UpgradeRequiredIndicator.vue';
import { FeatureTypes } from '@/components/Billing/billing-types';
import RoleSelector from '@/react_app/common/RoleSelector';

export default /*#__PURE__*/_defineComponent({
  __name: 'RoleSelector',
  setup(__props) {

const ReactRoleSelector = applyReactInVue(RoleSelector);
const { useHasCapability } = useBilling();
const hasCapability = useHasCapability();
const isUpgradeRequired = (billingFeatureId: FeatureTypes) => !hasCapability.value(billingFeatureId);
const openUpgrade = (e: unknown, billingFeatureId: FeatureTypes) => {
	if (isUpgradeRequired(billingFeatureId)) {
		UpgradeRequiredIndicator.setup().openUpgrade(e, billingFeatureId);
	}
};

return { __sfc: true,ReactRoleSelector, useHasCapability, hasCapability, isUpgradeRequired, openUpgrade }
}

})